import {Component, inject, Input} from '@angular/core';
import {Match} from '../../../../../model/events/Match';
import {Participant} from '../../../../../model/participants/Participant';
import {environment} from '../../../../../../environments/environment';
import {ErrorType} from '../../../../../model/error-type';
import {RestErrorHelper} from '../../../../../helper/rest-error-helper';
import {EventHelper} from '../../../event/event-helper';
import {Player} from '../../../../../model/participants/Player';
import {MessageComponent} from '../../../../../components/generic/message/message.component';
import {NgForOf, NgIf} from '@angular/common';
import {Button} from 'primeng/button';
import {TooltipModule} from 'primeng/tooltip';
import {TranslateModule} from '@ngx-translate/core';
import {DividerModule} from 'primeng/divider';
import {SetlegmodePipe} from '../../../../../pipes/setlegmode.pipe';
import {SwitchComponent} from '../../../common/switch/switch.component';
import { FittextDirective } from '../../../../../directives/fittext/fittext.directive';

@Component({
  standalone: true,
  selector: 'app-spiel-scorer-ansicht',
  templateUrl: './spiel-scorer-ansicht.component.html',
  imports: [
    MessageComponent,
    NgIf,
    NgForOf,
    TooltipModule,
    TranslateModule,
    FittextDirective,
    DividerModule,
    SetlegmodePipe,
    SwitchComponent,
    Button
  ],
  styleUrls: ['./spiel-scorer-ansicht.component.scss']
})
export class SpielScorerAnsichtComponent
{
  private restErrorHelper = inject(RestErrorHelper);

  errorMsg: ErrorType;
  isMobile: boolean;
  dataLoaded: boolean;
  statistics: any[];
  @Input() set statisticsData(value: any)
  {
    this.statistics = value;
    this.initStatistics();
  }
  matchIntern: Match;
  @Input() set match(value: Match)
  {
    this.matchIntern = value;
    this.initStatistics();
  }

  withPlayers: boolean;
  multiplePlayersView: boolean;

  maxFontSizePlayer = 20;
  currentLegIndex = 0;

  matchData: any;
  hasSingleDarts: boolean;
  showSingleDarts: boolean;
  showStartPlayer: boolean;

  constructor()
  {
    this.onResize();
  }

  private initStatistics(): void
  {
    if (!this.statistics || !this.matchIntern)
      return;

    this.withPlayers = EventHelper.isStatisticsByPlayer(this.matchIntern.event);
    console.log('withPlayers: ' + this.withPlayers, this.matchIntern);

    try
    {
      this.hasSingleDarts = false;
      this.statistics.sort((x, y) => this.compareStatistics(x, y));
      console.log('initStatistics(): ', this.statistics);

      this.initMatchData();

      let legIndex = 0;
      let firstLeg = true;
      let totalLegIndex = 0;

      for (const statistic of this.statistics)
      {
        if (statistic.type === 'MATCH')
        {
          if (statistic.playerIndex === 0 && statistic.playerPosition === 0)
            this.matchData.x01 = statistic.startPoints;
        }
        else if (statistic.type === 'LEG')
        {
          if (firstLeg)
            firstLeg = false;
          else
          {
            if (statistic.playerIndex === 0 && statistic.playerPosition === 0)
              legIndex++;
          }

          if (statistic.playerIndex === 0 && statistic.playerPosition === 0)
          {
            this.matchData.legs[legIndex] =
              {
                throws: [],
                legIndex: statistic.legIndex,
                setIndex: statistic.setIndex,
                startingPlayerIndex: this.getStartPlayerIndex(statistic.legIndex, statistic.setIndex),
                startingPlayerPosition: this.getStartPlayerPosition(statistic.legIndex, statistic.setIndex),
                totalLegIndex: totalLegIndex++,
                winnerDarts: this.getWinnerDarts(statistic.legIndex, statistic.setIndex),
                // scoreLeft: this.getScoreLeft(statistic.legIndex, statistic.setIndex),
                scoreLeft: [],
                isBreak: [],
                winnerPlayerIndex: this.getWinnerPlayerIndex(statistic.legIndex, statistic.setIndex),
              };
            if (!this.matchData.sets[statistic.setIndex])
            {
              this.matchData.sets[statistic.setIndex] = {
                index: statistic.setIndex,
                legsCount: this.countLegsInSet(statistic.setIndex)
              };
            }

            this.initLegStatistics(legIndex, statistic.legIndex, statistic.setIndex);
          }

          // console.log('addThrowsToThrow, legIndex: ' + legIndex + ', playerIndex: ' + statistic.playerIndex);
          // if (legIndex < this.matchData.legs.length)
          this.addThrowsToThrow(statistic, this.matchData.legs[legIndex].throws);
        }
      }

      console.log('MatchData: ', this.matchData);
      this.dataLoaded = true;
    }
    catch (ex: any)
    {
      console.error('Fehler bei initStatistics: ', ex);
      this.errorMsg = this.restErrorHelper.getErrorType(ex);
    }
  }

  private initLegStatistics(legIndex: number, leg: number, set: number): void
  {
    for (const player of this.matchData.players)
    {
      let isBreak = false;
      let scoreLeft = 0;

      for (const statistic of this.statistics)
      {
        if (statistic.type === 'LEG' && leg === statistic.legIndex && set === statistic.setIndex &&
          statistic.playerIndex === player.playerIndex && statistic.playerPosition === player.playerPosition)
        {
          if (!statistic.won)
            scoreLeft = statistic.startPoints - statistic.scoreTotal;
          if (statistic.won && statistic.isBreak)
            isBreak = true;
        }
      }

      this.matchData.legs[legIndex].scoreLeft.push(scoreLeft);
      this.matchData.legs[legIndex].isBreak.push(isBreak);
    }
  }

  private initMatchData(): void
  {
    this.showStartPlayer = false;
    if (this.withPlayers || this.matchIntern.participants?.length > 2)
    {
      this.matchData = {players: [], singlePlayers: []};

      for (const statistic of this.statistics)
      {
        if (statistic.type === 'MATCH' && statistic.player)
        {
          this.matchData.players.push(this.createMatchPlayer(statistic.player, statistic.playerIndex,
            statistic.playerPosition));
        }
      }
    }
    else
    {
      this.matchData = {
        players: [
          this.createMatchPlayerParticipant(this.matchIntern.participantHome, 0),
          this.createMatchPlayerParticipant(this.matchIntern.participantGuest, 1)
        ],
        singlePlayers: []
      };
    }
    this.matchData.legs = [];
    this.matchData.sets = [];

    this.matchData.countPlayersPerParticipant = 1;
    for (const statistic of this.statistics)
    {
      if (statistic.type === 'MATCH' && statistic.playerPosition > 0 &&
        statistic.playerPosition >= this.matchData.countPlayersPerParticipant)
      {
        this.matchData.countPlayersPerParticipant = statistic.playerPosition + 1;
      }

      if (statistic.type === 'MATCH' && statistic.players?.length > 0)
      {
        this.showStartPlayer = true;
        for (const player of statistic.players)
          this.matchData.singlePlayers.push(player);
      }
    }

    this.multiplePlayersView = !(this.matchData.countPlayersPerParticipant > 1) && this.matchData.players?.length > 2;
  }

  public getStartPlayerName(participantIndex: number): string
  {
    if (this.matchData?.singlePlayers && this.matchData.legs?.length > 0 && this.currentLegIndex < this.matchData.legs.length)
    {
      if (this.matchData.legs[this.currentLegIndex]?.throws?.length > 0)
      {
        const throwObj = this.matchData.legs[this.currentLegIndex].throws[0][participantIndex];
        if (throwObj?.playerId > 0)
          return this.getPlayerNameFromPlayerId(throwObj.playerId);
      }
    }
    return '-';
  }

  private getPlayerNameFromPlayerId(playerId: number): string
  {
    if (this.matchData?.singlePlayers)
    {
      for (const player of this.matchData.singlePlayers)
      {
        if (player.id === playerId)
          return player.name;
      }
    }
    return '-';
  }

  private createMatchPlayer(player: Player, playerIndex: number, playerPosition: number): any
  {
    return {
      name: player?.displayName,
      playerIndex,
      playerPosition
    };
  }
  private createMatchPlayerParticipant(participant: Participant, playerIndex: number): any
  {
    return {
      name: participant?.displayName,
      playerIndex,
      playerPosition: 0
    };
  }

  private getStartPlayerIndex(leg: number, set: number): number
  {
    for (const statistic of this.statistics)
    {
      if (statistic.type === 'LEG' && leg === statistic.legIndex && set === statistic.setIndex && statistic.startPlayer)
        return statistic.playerIndex;
    }
    return undefined;
  }
  private getStartPlayerPosition(leg: number, set: number): number
  {
    for (const statistic of this.statistics)
    {
      if (statistic.type === 'LEG' && leg === statistic.legIndex && set === statistic.setIndex && statistic.startPlayer)
        return statistic.playerPosition;
    }
    return undefined;
  }
  private getWinnerPlayerIndex(leg: number, set: number): number
  {
    for (const statistic of this.statistics)
    {
      if (statistic.type === 'LEG' && leg === statistic.legIndex && set === statistic.setIndex && statistic.won)
        return (statistic.playerIndex * this.matchData.countPlayersPerParticipant) + statistic.playerPosition;
    }
    return undefined;
  }
  private getWinnerDarts(leg: number, set: number): number
  {
    for (const statistic of this.statistics)
    {
      if (statistic.type === 'LEG' && leg === statistic.legIndex && set === statistic.setIndex && statistic.won)
        return statistic.dartsTotal;
    }
    return undefined;
  }

  private countLegsInSet(set: number): number
  {
    return this.statistics.filter(s => s.type === 'LEG' && s.setIndex === set && s.playerIndex === 0).length;
  }

  private addThrowsToThrow(statistic: any, legThrows: any[]): void
  {
    let currentScore = statistic.startPoints;
    let index = 0;
    if (!statistic.statisticThrows)
      return;

    for (const statisticThrow of statistic.statisticThrows)
    {
      if (statisticThrow.indexInLeg <= 0)
        continue;

      while (legThrows.length < statisticThrow.indexInLeg)
        legThrows.push([]);

      currentScore -= statisticThrow.total;
      const lastThrowForPlayer = index === statistic.statisticThrows.length - 1;
      const strikeThroughPoints = currentScore >= 0 && currentScore <= 180;
      const colIndex = (statistic.playerIndex * this.matchData.countPlayersPerParticipant) + statistic.playerPosition;
      // console.log('legThrows count: ' + legThrows.length + ', indexInLeg: ' + statisticThrow.indexInLeg +
      //   ', statisticThrow: ', statisticThrow);
      legThrows[statisticThrow.indexInLeg - 1][colIndex] =
        {
          score: currentScore,
          points: statisticThrow.total,
          strikeThroughPoints,
          strikeThroughScore: !lastThrowForPlayer && (currentScore > 0 && currentScore <= 180),
          dart1: statisticThrow.dart1,
          dart2: statisticThrow.dart2,
          dart3: statisticThrow.dart3,
          multiplicator1: statisticThrow.multiplicator1,
          multiplicator2: statisticThrow.multiplicator2,
          multiplicator3: statisticThrow.multiplicator3,
          checked: statisticThrow.checked,
          playerId: statisticThrow.playerId
        };
      if (strikeThroughPoints && statisticThrow.indexInLeg - 2 >= 0)
        legThrows[statisticThrow.indexInLeg - 2][colIndex].strikeThroughScore = true;

      if (statisticThrow.dart1 >= 0)
        this.hasSingleDarts = true;

      index++;
    }
  }

  private compareStatistics(x: any, y: any): number
  {
    if (x.setIndex < y.setIndex)
      return -1;
    else if (x.setIndex > y.setIndex)
      return 1;
    else
    {
      if (x.legIndex < y.legIndex)
        return -1;
      else if (x.legIndex > y.legIndex)
        return 1;
      else
      {
        if (x.playerIndex < y.playerIndex)
          return -1;
        else if (x.playerIndex > y.playerIndex)
          return 1;
        else
        {
          if (x.playerPosition < y.playerPosition)
            return -1;
          else if (x.playerPosition > y.playerPosition)
            return 1;
          else return 0;
        }
      }
    }
  }

  public onResize(): void
  {
    this.isMobile = window.innerWidth < environment.mobileSize;
  }
}
